'use client';

import { Box, Stack } from '@mui/material';
import { Line } from './components/line/line';
import { Starfield } from './components/starfield/starfield';

export function Wrapper({ children }: { children: React.ReactNode }) {
  return (
    <Box position="relative" width="100%" id="home-wrapper">
      {/* Background comes from starfield */}
      <Starfield />
      <Line />
      <Stack
        justifyContent="flex-start"
        flexGrow={1}
        direction="column"
        pb={8}
        alignItems="center"
        sx={{
          gap: {
            xs: '120px',
            md: '140px',
            lg: '200px',
          },
        }}
        zIndex={150}
        position="relative"
      >
        {children}
      </Stack>
    </Box>
  );
}
